import * as __WEBPACK_EXTERNAL_MODULE__badge_js_d026ac0a__ from "./badge.js";
import * as __WEBPACK_EXTERNAL_MODULE__badge_variants_js_87930c11__ from "./badge-variants.js";
var __webpack_exports__Badge = __WEBPACK_EXTERNAL_MODULE__badge_js_d026ac0a__.Badge;
var __webpack_exports__badgeVariants = __WEBPACK_EXTERNAL_MODULE__badge_variants_js_87930c11__.badgeVariants;
export { __webpack_exports__Badge as Badge, __webpack_exports__badgeVariants as badgeVariants };
